import type {
  DepositFlowConfig,
  DepositInitialAmount,
} from './depositFlowConfig'

/** Narrows a deposit config to one with an amount that is explicitly locked. */
export function isLockedDeposit(
  config: DepositFlowConfig,
): config is DepositFlowConfig & { initialAmount: DepositInitialAmount } {
  return config.lockAmount === true && !!config.initialAmount
}
